<template>
  <div>
    <input class="" type="file" ref="uploadInput" @change="file__changed">

  </div>
</template>


<script>

import PotentialShopifySite from "../../../models/PotentialShopifySite";

export default {
  data () {
    return {
      file_reader: new FileReader(),
      upload_progress: -1,
      selected_category_index: 0
    }
  },
  mounted(){
    this.file_reader.addEventListener('load', this.fileReader__loaded);

  },
  watch:{

  },
  computed: {

  },
  methods: {
    file__changed(event) {
      if (event.target.files && event.target.files[0]) {
        this.file_reader.readAsBinaryString(event.target.files[0]);
      }
    },
    async fileReader__loaded(event){
      let potential_sites = this.parceCSV(event.target.result);
      let i = 0;
      let count = potential_sites.length;
      for(let site of potential_sites) {
        console.log(`site ${i} / ${count} = ${(i/count).toFixed(2)}`, site);
        await site.save();
        i++;
      }
    },
    parceCSV(data) {
      let output = [];
      let lines = data.split("\n");
      let headers = lines[0].split(",");
      for(let i = 1; i < lines.length; i++) {
        let obj = {};
        let line = lines[i].split(",");
        for(let j = 0; j < headers.length; j++){
          obj[headers[j]] = line[j] == undefined ? null : line[j];
        }

        output.push(PotentialShopifySite.instanceFromCsvLine(obj));
      }

      return output;
    }
  }
}
</script>
